/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Dur_HourInputs */

const en_dur_hour = /** @type {(inputs: Dur_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hour`)
};

const he_dur_hour = /** @type {(inputs: Dur_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} שעה`)
};

/**
* | output |
* | --- |
* | "{count} hour" |
*
* @param {Dur_HourInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const dur_hour = /** @type {((inputs: Dur_HourInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dur_HourInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dur_hour(inputs)
	return he_dur_hour(inputs)
});